import e from "../_virtual/_plugin-vue_export-helper.js";
import t from "./SchemaPropertyDetail.vue.script.js";
/* empty css                                   */
//#region src/schema/SchemaPropertyDetail.vue
var n = /*#__PURE__*/ e(t, [["__scopeId", "data-v-8b57daa7"]]);
//#endregion
export { n as default };

//# sourceMappingURL=SchemaPropertyDetail.vue.js.map